import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import ContentBlock from "@/components/storyboard/ContentBlock";
import { titledBodyMarkdown } from "@/components/storyboard/text/utils/titledBodyMarkdown";
import type { TextTitledBodyData } from "@/types/storyboard";

interface Props {
  data: TextTitledBodyData | string;
}

export const TextExample = ({ data }: Props) => {
  const isMarkdown = typeof data === "string";
  const title = isMarkdown ? undefined : data.title;
  const body = isMarkdown ? data : titledBodyMarkdown(data);

  return (
    <ContentBlock title={title}>
      <div className="prose max-w-full text-primary">
        <CourseMarkdown>{body}</CourseMarkdown>
      </div>
    </ContentBlock>
  );
};
